import { IUserList } from './../interface';
import {
  Component, OnInit, ViewChild, Input, Output,
  EventEmitter, TemplateRef, ElementRef, Renderer2, SimpleChanges
} from '@angular/core';
import { GridLine, EditSettingsModel, RowSelectEventArgs, GridComponent } from '@syncfusion/ej2-angular-grids';
import { FormArray, FormBuilder } from '@angular/forms';
import { BsModalRef, BsModalService, ModalDirective } from 'ngx-bootstrap/modal';
import { ToastComponent } from '@syncfusion/ej2-angular-notifications';
import { UserService } from 'src/app/services/user.service';
import { SelectionSettingsModel } from '@syncfusion/ej2-angular-grids';
import { TempDataService } from '../tempData.service';
import { AppService } from 'src/app/services/app.service';
import { timer } from 'rxjs';
import { parse } from 'querystring';

@Component({
    selector: 'app-select-template',
    templateUrl: './select-template.component.html',
    styleUrls: ['./select-template.component.scss'],
    standalone: false
})
export class SelectTemplateComponent implements OnInit {
  public selectionOptions: SelectionSettingsModel;
  @Input() AllData = [];
  @Input() ActiveFormArray: FormArray;
  @Input() public SelectionName;
  @Output() isFormDirty: EventEmitter<any> = new EventEmitter<any>();
  @Input() ModuleName;
  @Input() LastExportDate = [];
  @Input() PermissionsWebhooksubscription;
  @Input() facilityEditRight: boolean;
  @Input() disableStoreSelection: boolean;
  @Input() auctionId;
  @Input() IsAcutionDateList:boolean = false;
  @Input() IsReports: boolean = false;
  @Input() isAuditInProgressOrCompleted: boolean = false;
  @Input() initialFacilityIds: any[] = [];
  @Input() initialStoreGroupIds: any[] = [];

  ////////// MFA Settings Related ///////////
  displayCountries = false;
  displayIp = false;
  @Output() editNamedLoc: EventEmitter<any> = new EventEmitter<any>();


  ///////////////////////

  filterEnable = true;
  AllDataDisplay = [];
  ActiveDataDisplay = [];
  tempGirdUserData = [];
  tempFilterUserData = [];
  AllFilterData = [];
  AllFilterUserData = [];
  AllUsers = [];
  AllNotifications = [];
  ActiveFilterData = [];
  ActiveHeader = '';
  AllDataHeader = '';
  exportDateHeader = 'Export Date';
  records: Object[];
  activeRecords: Object[];
  tempArray: Object[];
  arrayLength = [];
  TempActiveData = [];
  TempAllData = [];
  ActiveData = [];
  tempAllData = [];
  tempAllFilterData = [];
  tempActiveGridData = [];
  masterFilterActiveData = [];
  isFilterActive: boolean;
  isFilterAll: boolean;
  public ActiveRecords: Object[];
  pageSize = 20;
  modalRef: BsModalRef;
  modalRefEdit: BsModalRef;
  public pageSettings: Object;
  public filterSettings: Object;
  public formatoptions: Object;
  public editSettings: EditSettingsModel;
  public initialPage: Object;
  public lines: GridLine;
  queryAll: Object = [];
  queryActive: Object;
  isUnits;
  isUnitType;
  SplitModuleUnit;
  disableFilter = true;
  disableFilterActive = true;
  activeMerchModalName = 'Active Merchandise';
  allMerchModalName = 'All Merchandise';
  activeUsersModalName = "Active Users";
  allUsersModalName = "All Users";
  @ViewChild('gridFilterMercActivedata', { static: true }) public gridFilterMercActivedata: GridComponent;
  @ViewChild('gridFilterMercPackActivedata', { static: true }) public gridFilterMercPackActivedata: GridComponent;
  @ViewChild('gridFilterMercAlldata', { static: true }) public gridFilterMercAlldata: GridComponent;
  @ViewChild('gridFilterMercPackAlldata', { static: true }) public gridFilterMercPackAlldata: GridComponent;
  @ViewChild('gridFilterStoreActivedata', { static: true }) public gridFilterStoreActivedata: GridComponent;
  @ViewChild('allDatastoresFilter', { static: true }) allDatastoresFilter: ModalDirective;
  @ViewChild('activeDataStoresFilter', { static: true }) activeDataStoresFilter: ModalDirective;
  @ViewChild('avialableDataUsersFilter', { static: true }) avialableDataUsersFilter: TemplateRef<any>;
  @ViewChild('allDataUsersFilter', { static: true }) allDataUsersFilter: ModalDirective;
  @ViewChild('activeDataUsersGridFilter', { static: true }) activeDataUsersGridFilter: ModalDirective;
  @ViewChild('activeDataUsersFilter', { static: true }) activeDataUsersFilter: TemplateRef<any>;
  @ViewChild('allDataMercFilter', { static: true }) allDataMercFilter: ModalDirective;
  @ViewChild('activeDataMercFilter', { static: true }) activeDataMercFilter: ModalDirective;
  @ViewChild('allDataInsurancefilter', { static: true }) allDataInsurancefilter: ModalDirective;

  @ViewChild('allDataunitsFilter', { static: true }) allDataunitsFilter: ModalDirective;
  @ViewChild('activeDataunitsFilter', { static: true }) activeDataunitsFilter: ModalDirective;
  @ViewChild('allDataunitTypesFilter', { static: true }) allDataunitTypesFilter: ModalDirective;
  @ViewChild('activeDataunitTypesFilter', { static: true }) activeDataunitTypesFilter: ModalDirective;
  @ViewChild('allDataFeesAndCharges', { static: true }) allDataFeesAndCharges: ModalDirective;
  @ViewChild('allLateandLien', { static: true }) allLateandLien: ModalDirective;
  @ViewChild('activeDataFeesAndCharges', { static: true }) activeDataFeesAndCharges: ModalDirective;
  @ViewChild('activeDataLateAndLien', { static: true }) activeDataLateAndLien: ModalDirective;
  @ViewChild('allDataMercPackFilter', { static: true }) allDataMercPackFilter: ModalDirective;
  @ViewChild('activeDataMercPackFilter', { static: true }) activeDataMercPackFilter: ModalDirective;
  @ViewChild('activeInsurancefilter', { static: true }) activeInsurancefilter: ModalDirective;
  @ViewChild('AllDataUnitGroupsfilter', { static: true }) allDataUnitGroupsfilter: ModalDirective;
  @ViewChild('ActiveDataUnitGroupsFilter', { static: true }) activeDataUnitGroupsFilter: ModalDirective;
  @ViewChild('AllDataTaxfilter', { static: true }) allDataTaxfilter: ModalDirective;
  @ViewChild('ActiveDataTaxFilter', { static: true }) activeDataTaxFilter: ModalDirective;
  @ViewChild('AllDataUserGroupfilter', { static: true }) AllDataUserGroupfilter: ModalDirective;
  @ViewChild('ActiveDataUserGroupFilter', { static: true }) ActiveDataUserGroupFilter: ModalDirective;


  @ViewChild('AllDataStoreGroupfilter', { static: true }) allDataStoreGroupfilter: ModalDirective;
  @ViewChild('ActiveDataStoreGroupFilter', { static: true }) activeDataStoreGroupFilter: ModalDirective;
  @ViewChild('gridActiveStoreGroupData', { static: true }) public gridActiveStoreGroupData: GridComponent;
  @ViewChild('gridAllStoreGroupData', { static: true }) public gridAllStoreGroupData: GridComponent;

  @ViewChild('ActiveFilterIcon', { static: false }) activeFilterIcon: ElementRef;
  @ViewChild('AllFilterIcon', { static: false }) allFilterIcon: ElementRef;
  @ViewChild('gridAlldata', { static: false })
  public gridAlldata: GridComponent;
  @ViewChild('gridActiveData', { static: false })
  public gridActiveData: GridComponent;
  @ViewChild('gridFilterAlldata', { static: true })
  public gridallFilterUser: GridComponent;
  @ViewChild('gridFilterAvailabledata', { static: false })
  public gridallFilterAvailableUser: GridComponent;
  @ViewChild('gridFilterStoreAlldata', { static: true })
  public gridallFilterAllStores: GridComponent;
  @ViewChild('gridFilterUnitsAlldata', { static: true })
  public gridFilterUnitsAlldata: GridComponent;
  @ViewChild('gridFilterUnitsActivedata', { static: true })
  public gridFilterUnitsActivedata: GridComponent;
  @ViewChild('gridFilterUnitsTypeAlldata', { static: true })
  public gridFilterUnitsTypeAlldata: GridComponent;
  @ViewChild('gridFilterUnitsTypeActivedata', { static: true })
  public gridFilterUnitsTypeActivedata: GridComponent;
  @ViewChild('gridFilterFeesAndChargesAlldata', { static: true })
  public gridFilterFeesAndChargesAlldata: GridComponent;
  @ViewChild('gridFilterLateAndLienAlldata', { static: true })
  public gridFilterLateAndLienAlldata: GridComponent;
  @ViewChild('gridActivedataInsurance', { static: true })
  public gridActivedataInsurance: GridComponent;
  @ViewChild('gridAlldataInsurance', { static: true })
  public gridAlldataInsurance: GridComponent;
  @ViewChild('gridFilterLateAndLienActivedata', { static: true })
  public gridFilterLateAndLienActivedata: GridComponent;
  @ViewChild('gridFilterFeesAndChargesActivedata', { static: true })
  public gridFilterFeesAndChargesActivedata: GridComponent;
  @ViewChild('toasttype', { static: true })
  public toastObj: ToastComponent;
  @ViewChild('gridAllUnitsGroupsData', { static: true })
  public gridAllUnitsGroupsData: GridComponent;
  @ViewChild('gridActiveUnitsGroupsData', { static: true })
  public gridActiveUnitsGroupsData: GridComponent;
  @ViewChild('gridAllTaxData', { static: true })
  public gridAllTaxData: GridComponent;
  @ViewChild('gridActiveTaxData', { static: true })
  public gridActiveTaxData: GridComponent;
modalConfig = {
  backdrop: 'static'
};
  public toastPosition: Object = { X: 'Right', Y: 'top' };
  public target: HTMLElement = document.body;
  public true = true;
  public toasts: { [key: string]: Object }[] = [
    { content: 'Filter has been Applied.', cssClass: 'e-toast-success' },
    { content: 'Filter has been Cleared.', cssClass: 'e-toast-success' }
  ];
  sub: any;
  sub2: any;
  sub3: any;
  sub4: any;
  sub5: any;
  isOninitExecuted = false;

  public actionBegin(args: any, grid): void {
    if (args.requestType === 'filtering') {
      this.disableFilter = false;
    }
  }

  public actionBeginActive(args: any, grid): void {
    if (args.requestType === 'filtering') {
      this.disableFilterActive = false;
    }
  }

  constructor(public formBuilder: FormBuilder,
    private modalService: BsModalService,
    private userService: UserService,
    public rendrer: Renderer2,
    private tempDataService: TempDataService,
    private appService: AppService) { }
  
  onGridDataBound(): void {
  const elements = document.querySelectorAll('.e-templatecell[aria-colindex="3"]');
  elements.forEach((el: Element) => {
    (el as HTMLElement).style.paddingBottom = '0px';
  });
}

  stores = [];

  ngOnInit() {
    this.selectionOptions = { checkboxOnly: true, persistSelection: true };
    this.initialPage = { pageSize: 15, pageCount: 1 };
    this.filterSettings = { mode: 'Immediate', immediateModeDelay: '100' };
    this.isUnits = false;
    this.isUnitType = false;
    if (this.SelectionName === 'Store') {
      this.ActiveHeader = 'Active Stores';
      this.AllDataHeader = 'All Stores';
    } else if (this.SelectionName === 'AvailableStore') {
      this.ActiveHeader = 'Active Stores';
      this.AllDataHeader = 'Available Stores';
    } else if (this.SelectionName === 'Merchandise') {
      this.ActiveHeader = 'Active Merchandise';
      this.AllDataHeader = 'All Merchandise';
    } else if (this.SelectionName === 'API') {
      this.ActiveHeader = "Active API's";
      this.AllDataHeader = "All API's";
    } else if (this.SelectionName === 'Users') {
      this.ActiveHeader = 'Active Users';
      this.AllDataHeader = 'All Users';
    } else if (this.SelectionName === 'StoreGroup') {
      this.ActiveHeader = 'Active Store Groups';
      this.AllDataHeader = 'All Store Groups';
    } else if (this.SelectionName === 'AuditFacility') {
      this.ActiveHeader = 'Active Stores';
      this.AllDataHeader = 'All Stores';
    } else if (this.SelectionName === 'AvailableStoreGroup') {
      this.ActiveHeader = 'Active Store Groups';
      this.AllDataHeader = 'Available Store Groups';
    } else if (this.SelectionName === 'AvailableUser') {
      this.ActiveHeader = 'Active Users';
      this.AllDataHeader = 'Available Users';
      this.tempGirdUserData = this.AllData;
      this.tempFilterUserData = this.AllData;
      this.AllUsers = this.tempUsersServiceGet;
    } else if (this.SelectionName === 'MerchandisePacks') {
      this.ActiveHeader = 'Active Packs';
      this.AllDataHeader = 'All Packs';
    } else if (this.SelectionName === 'TruckRental') {
      this.ActiveHeader = 'Assigned Trucks';
      this.AllDataHeader = 'All Trucks';
    } else if (this.SelectionName === 'AvailableUnits') {
      this.isUnits = true;
      this.isUnitType = false;
      this.ActiveHeader = 'Active Units';
      this.AllDataHeader = 'Available Units';
      this.SelectionName = 'Units';
    } else if (this.SelectionName === 'Units') {
      this.isUnits = true;
      this.isUnitType = false;
      this.ActiveHeader = 'Active Units';
      this.AllDataHeader = 'All Units';
    } 
    else if (this.SelectionName === 'PricingCategoryUnits') { 
      this.isUnits = true;
      this.isUnitType = false;
      this.ActiveHeader = 'Active Units';
      this.AllDataHeader = 'Available Units';
      this.SelectionName = 'Units';
    } 
    else if (this.SelectionName === 'Unit Types') {
      this.isUnitType = true;
      this.isUnits = false;
      this.ActiveHeader = 'Active Unit Types';
      this.AllDataHeader = 'All Unit Types';
    } else if (this.SelectionName === 'Fees & Charges') {
      this.ActiveHeader = 'Active Fees & Charges';
      this.AllDataHeader = 'All Fees & Charges';
    } else if (this.SelectionName === 'Late & Lien') {
      this.ActiveHeader = 'Active Late & Lien';
      this.AllDataHeader = 'All Late & Lien';
    } else if (this.SelectionName == 'Insurance') {
      this.ActiveHeader = 'Active Insurance';
      this.AllDataHeader = 'All Insurance';
    } else if (this.SelectionName === 'UnitGroups') {
      this.ActiveHeader = 'Active Unit Groups';
      this.AllDataHeader = 'All Unit Groups';
    } else if (this.SelectionName == 'Taxes') {
      this.ActiveHeader = 'Included in Group';
      this.AllDataHeader = 'All Taxes';
    } else if (this.SelectionName == 'UserGroups') {
      this.AllDataHeader = 'All User Groups';
      this.ActiveHeader = 'Active User Groups';
    } else if (this.SelectionName == 'MFAUsers') {
      this.AllDataHeader = 'Active Users';
      this.ActiveHeader = 'Excluded Users';
    } else if (this.SelectionName == 'MFALocations') {
      this.AllDataHeader = 'Active Locations';
      this.ActiveHeader = 'Excluded Locations';
    } else if (this.SelectionName == 'AvailableNotifications') {
      this.ActiveHeader = 'Active Notifications';
      this.AllDataHeader = 'All Notifications';
      this.tempGirdUserData = this.AllData;
      this.tempFilterUserData = this.AllData;
      this.AllNotifications = this.tempNotificationServiceGet;
    }  else if (this.SelectionName == 'SSOUsers') {
      this.AllDataHeader = 'Active Users';
      this.ActiveHeader = 'Excluded Users';
    }

    if (this.ModuleName === "FacilitySection") {
      this.SplitModuleUnit = true;
    }
    this.lines = 'Both';
    this.ActiveData = [];
    this.isOninitExecuted = true;
    this.loadActiveTable();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['SelectionName'] !== undefined) {
      if (this.SelectionName && this.isOninitExecuted) {
        if (this.SelectionName === 'Store') {
          this.ActiveHeader = 'Active Stores';
          this.AllDataHeader = 'All Stores';
        } else if (this.SelectionName === 'AvailableStore') {
          this.ActiveHeader = 'Active Stores';
          this.AllDataHeader = 'Available Stores';
        } else if (this.SelectionName === 'StoreGroup') {
          this.ActiveHeader = 'Active Store Groups';
          this.AllDataHeader = 'All Store Groups';
        } else if (this.SelectionName === 'AvailableStoreGroup') {
          this.ActiveHeader = 'Active Store Groups';
          this.AllDataHeader = 'Available Store Groups';
        }
        this.ActiveData = [];
        this.loadActiveTable();
      }
    }
    if (this.SelectionName === 'Units' && (changes['ActiveFormArray'] || changes['AllData']) && this.isOninitExecuted) {
    this.ActiveData = [];
    this.loadActiveTable();
    }
  }

  getUsers() {
    this.userService.GetFNameOrLNameOfUsers().subscribe((response: IUserList[]) => { this.AllUsers = response; });
  }

  getAvailableUsers() {
    this.userService.getavailableUsers().subscribe((response: IUserList[]) => { this.AllUsers = response; });
  }

  loadActiveTable() {
    this.tempAllData = this.AllData;
    for (let i = 0; i < this.ActiveFormArray.controls.length; i++) {
      const cnt = this.ActiveFormArray.controls[i];
      this.ActiveData.push(this.ActiveFormArray.controls[i].value);
    }
    this.populateActiveList();
    this.tempActiveGridData = this.getActiveFilterUsers(this.ActiveData, this.AllData);
    this.masterFilterActiveData = this.tempActiveGridData;

    if (this.SelectionName === 'AvailableUser') {
      this.AllFilterData = this.AllData;
      this.AllFilterData = this.removeAllData(this.ActiveData, this.AllFilterData);
    }
    if (this.SelectionName == 'AvailableNotifications') {
      this.AllFilterData = this.AllData;
      this.AllFilterData = this.removeAllData(this.ActiveData, this.AllFilterData);
    }
    this.AllData = this.removeAllData(this.ActiveData, this.AllData);
    if (this.SelectionName === 'SSOUsers') {
      this.AllDataDisplay = this.ActiveData;
      this.ActiveDataDisplay = this.AllData;
    }
    else {
      this.AllDataDisplay = this.AllData;
      this.ActiveDataDisplay = this.ActiveData;
    }
    this.hidePercentageFilter();
  }

  populateActiveList() {
    var tempAllList = [];
    if (this.SelectionName === 'Store' || this.SelectionName === 'AvailableStore') {
      if (this.ModuleName === 'ReportsModule') {
        tempAllList = this.tempStorageListForReports ? JSON.parse(JSON.stringify(this.tempStorageListForReports)) : [];
      } else {
        tempAllList = this.tempStorageList ? JSON.parse(JSON.stringify(this.tempStorageList)) : [];
      }
      if (this.ModuleName == 'AccountingInterface' || this.IsReports) {
        tempAllList.map(item => {
          const index = this.LastExportDate.findIndex(x => (x.FacilityId == item.Id));
          item['LastExportDate'] = index != -1 ? this.LastExportDate[index].FileDatetime : '';
        });
      }
    } else if (this.SelectionName === 'StoreGroup' || this.SelectionName === 'AvailableStoreGroup' || this.SelectionName === 'API' 
    || this.SelectionName === 'MFAUsers' || this.SelectionName === 'MFALocations'|| this.SelectionName === 'SSOUsers' || this.SelectionName === 'AuditFacility') {
      tempAllList = this.AllData;
    } else if (this.SelectionName === 'Merchandise') {
      tempAllList = this.tempMerchandiseServiceGet;
    } else if (this.SelectionName === 'MerchandisePacks') {
      tempAllList = this.tempMerchandisePackServiceGet;
    } else if (this.SelectionName === 'Users') {
      tempAllList = this.tempUsersServiceGet;
      tempAllList = this.getUserListActive(tempAllList);
    } else if (this.SelectionName === 'AvailableUser') {
      tempAllList = this.tempUsersServiceGet;
    } else if (this.SelectionName === 'TruckRental') {
      tempAllList = this.tempTruckRentalServiceGet;
    } else if (this.SelectionName === 'Units') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'Unit Types') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'Fees & Charges') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'Late & Lien') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'Insurance') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'UnitGroups') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'Taxes') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'UserGroups') {
      tempAllList = this.ActiveData;
    } else if (this.SelectionName === 'AvailableNotifications') {
      tempAllList = this.tempNotificationServiceGet;
    }

    let tempActiveobj = [];

    if (this.SelectionName == 'Units' || this.SelectionName == 'Unit Types') {
      tempActiveobj = this.ActiveData;
    } else if (this.SelectionName == 'AvailableNotifications') {
      this.ActiveData = this.ActiveData.filter((element) => {
        const tempPos = tempAllList.findIndex(o => o.NotificationOptionId === element.NotificationOptionId);
        if (tempPos !== -1) {
          tempActiveobj.push(tempAllList[tempPos]);
        }
      });
    } else {
      this.ActiveData = this.ActiveData.filter((element) => {
        const tempPos = tempAllList.findIndex(o => o.Id === element.Id);
        if (tempPos !== -1) {
          tempActiveobj.push(tempAllList[tempPos]);
        }
      });
    }

    if (this.SelectionName === 'AvailableUser') {
      this.ActiveData = this.getUserListAvailable(tempActiveobj);
      this.tempAllFilterData = this.removeAllData(this.ActiveData, tempAllList);
    } else {
      this.ActiveData = tempActiveobj;
    }
    if (this.SelectionName === 'AvailableNotifications') {
      this.ActiveData = this.getNotificationListAvailable(tempActiveobj);
      this.tempAllFilterData = this.removeAllData(this.ActiveData, tempAllList);
    } else {
      this.ActiveData = tempActiveobj;
    }
    if (this.SelectionName !== 'AvailableStore' && this.AllData.length === 0) {
      this.AllData = tempAllList;
    }
    if (this.SelectionName !== 'Units' || this.SelectionName !== 'Unit Types') {
      if (this.AllData.length !== 0) {
        if (this.AllData[0].Id === 0) {
          this.AllData = [];
        }
      }
    }
  }

  getActiveFilterUsers(activeData, alldata) {
    let obj = [];
    if (this.SelectionName === 'Units') {
      for (let i = 0; i < activeData.length; i++) {
        if (activeData[i]) {
          const foundItem = alldata.find(o => o.UnitId === activeData[i].UnitId);
          if (foundItem) {
            obj.push(foundItem);
            obj[i].NotificationAlert = false;
          }
        }
      }
    } else if (this.SelectionName === 'AvailableNotifications') {
      for (let i = 0; i < activeData.length; i++) {
        if (activeData[i]) {
          obj.push(alldata.find(o => o.NotificationOptionId === activeData[i].Id));
        }
      }
    } else {
      for (let i = 0; i < activeData.length; i++) {
        if (activeData[i]) {
          obj.push(alldata.find(o => o.Id === activeData[i].Id));
        }
      }
    }
    obj = obj.filter(function (el) {
      return el !== undefined;
    });
    if (obj.length === 0) {
      obj = activeData;
    }
    return obj;
  }

  rowSelectedAllData(args: RowSelectEventArgs) {
    const selectedrecords = this.gridAlldata.getSelectedRecords();  // Get the selected records.
    this.records = selectedrecords;
  }

  rowSelectedActiveData(args: RowSelectEventArgs) {
    const selectedrecords = this.gridActiveData.getSelectedRecords();  // Get the selected records.
    this.activeRecords = selectedrecords;
  }

  validateAddToActiveGrid() {
    if (this.ModuleName == "WebHookSubscription") {
      if (this.PermissionsWebhooksubscription && this.PermissionsWebhooksubscription.CreateRight) {
        this.addToActiveGrid();
      }
    } else {
      this.addToActiveGrid();
    }
  }

  addToActiveGrid() {
    const selectedrecords = this.gridAlldata.getSelectedRecords();  // Get the selected records.
    this.records = selectedrecords;
    if (this.records.length !== 0) {
      this.ActiveData = this.ActiveData.concat(this.records);

      if (this.SelectionName === 'AvailableUser') {
        this.tempActiveGridData = this.getActiveFilterUsers(this.ActiveData, this.AllUsers);
      } else {
        this.tempActiveGridData = this.ActiveData;
      }
      if (this.SelectionName === 'AvailableNotifications') {
        this.tempActiveGridData = this.getActiveFilterUsers(this.ActiveData, this.AllUsers);
      } else {
        this.tempActiveGridData = this.ActiveData;
      }
      this.insertFormArrayData(this.ActiveFormArray, this.records);
      this.removeFromAllData(this.records);
      this.isFormDirty.emit(true);
      this.ActiveFilterData = this.ActiveData;
      if (this.isFilterAll === true) {
        this.removeFromAllDataDisplay(this.records);
      } else {
        this.AllDataDisplay = this.AllData;
      }
      if (this.isFilterActive !== true) {
        this.ActiveDataDisplay = this.ActiveData;
        //should remove the selected item- from allDatadisplay: if filter is applied and item moved
      } else {
        this.loadToActiveGrid(this.gridFilterStoreActivedata, 'filter');
      }
      this.records = [];

      this.masterFilterActiveData = this.tempActiveGridData;
      this.hidePercentageFilter();
    }
    this.gridAlldata.clearSelection();
  }

  removeFromAllDataDisplay(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
      if (this.SelectionName === 'Units') {
        const unitid = obj[i].UnitId;
        const objunit = this.AllDataDisplay.findIndex(o => o.UnitId === unitid);
        this.AllDataDisplay = [...this.AllDataDisplay.slice(0, objunit), ...this.AllDataDisplay.slice(objunit + 1)];
      } else if (this.SelectionName === 'AvailableNotifications') {
        const id = obj[i].NotificationOptionId;
        const objtax = this.ActiveDataDisplay.findIndex(o => o.NotificationOptionId === id);
        const result = this.ActiveDataDisplay.slice(0, objtax).concat(this.ActiveDataDisplay.slice(objtax + 1));
        this.ActiveDataDisplay = result;
      } else {
        const id = obj[i].Id;
        const objtax = this.AllDataDisplay.findIndex(o => o.Id === id);
        this.AllDataDisplay = [...this.AllDataDisplay.slice(0, objtax), ...this.AllDataDisplay.slice(objtax + 1)];
      }
    }
    this.gridAlldata.refresh();
  }

  insertFormArrayData(formArray: FormArray, records) {
    for (let k = 0; k < records.length; k++) {
      formArray.push(this.formBuilder.control(records[k]));
    }
  }

  validateAddToAllGrid() {
    if (this.ModuleName == "WebHookSubscription") {
      if (this.PermissionsWebhooksubscription && this.PermissionsWebhooksubscription.DeleteRight) {
        this.addToAllGrid();
      }
    } else {
      this.addToAllGrid();
    }
  }

  addToAllGrid() {
    var selectedrecords =[]
    selectedrecords = this.gridActiveData.getSelectedRecords();  // Get the selected records.
    if ((this.SelectionName == 'AuditFacility' || this.SelectionName == 'StoreGroup') && this.isAuditInProgressOrCompleted) {
      if (this.SelectionName == 'AuditFacility') {
        selectedrecords = selectedrecords.filter(x => !this.initialFacilityIds.includes(Number(x.Id)));
      }
      if (this.SelectionName == 'StoreGroup') {
        selectedrecords = selectedrecords.filter(x => !this.initialStoreGroupIds.includes(Number(x.Id)));
      }
    }
    if (this.SelectionName == 'AvailableNotifications') {
      selectedrecords.forEach((x) => {
        x.NotificationAlert= false;  // Set NotificationAlert to false for each selected record
      });
    } 
    if (this.SelectionName === 'MFAUsers') {
      selectedrecords = selectedrecords.filter(u => u.isSsoEnabledUser !== true);
    }
    this.activeRecords = selectedrecords;
    if (this.activeRecords.length !== 0) {
      this.AllData = this.AllData.concat(this.activeRecords);
      this.removeFromActiveData(this.activeRecords);

      if (this.SelectionName === 'AvailableUser') {
        this.AllFilterData = this.getActiveFilterUsers(this.AllData, this.AllUsers);
      } else {
        this.AllFilterData = this.AllData;
      }
      if(this.SelectionName === 'AvailableNotifications') {
        this.AllFilterData = this.getActiveFilterUsers(this.AllData, this.AllUsers);
      } else {
        this.AllFilterData = this.AllData;     
      }
      this.checkFilter();
      this.isFormDirty.emit(true);
      if (this.isFilterAll !== true) {
        this.AllDataDisplay = this.AllData;
      }
      if (this.isFilterActive === true) {
        this.removeFromActiveDataDisplay(this.activeRecords);
      } else {
        this.ActiveDataDisplay = this.ActiveData;
      }
      this.activeRecords = [];
      this.hidePercentageFilter();
    }
    this.gridActiveData.clearSelection();
  }

  removeFromActiveDataDisplay(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
      if (this.SelectionName === 'Units') {
        const id = obj[i].UnitId;
        const objtax = this.ActiveDataDisplay.findIndex(o => o.UnitId === id);
        const result = this.ActiveDataDisplay.slice(0, objtax).concat(this.ActiveDataDisplay.slice(objtax + 1));
        this.ActiveDataDisplay = result;
      } else if (this.SelectionName === 'AvailableNotifications') {
        const id = obj[i].NotificationOptionId;
        const objtax = this.ActiveDataDisplay.findIndex(o => o.NotificationOptionId === id);
        const result = this.ActiveDataDisplay.slice(0, objtax).concat(this.ActiveDataDisplay.slice(objtax + 1));
        this.ActiveDataDisplay = result;
      } 
      else {
        const id = obj[i].Id;
        const objtax = this.ActiveDataDisplay.findIndex(o => o.Id === id);
        const result = this.ActiveDataDisplay.slice(0, objtax).concat(this.ActiveDataDisplay.slice(objtax + 1));
        this.ActiveDataDisplay = result;
      }
    }
    this.gridActiveData.refresh();
  }

  removeFromAllData(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
      if (this.SelectionName === 'Units') {
        const unitid = obj[i].UnitId;
        const objunit = this.AllData.findIndex(o => o.UnitId === unitid);
        this.AllData = [...this.AllData.slice(0, objunit), ...this.AllData.slice(objunit + 1)];
      } else if (this.SelectionName === 'Unit Types') {
        const unittypeid = obj[i].UnitTypeId;
        const objunittype = this.AllData.findIndex(o => o.UnitTypeId == unittypeid);
        this.AllData = [...this.AllData.slice(0, objunittype), ...this.AllData.slice(objunittype + 1)];
      } else if (this.SelectionName === 'AvailableNotifications') {
        const id = obj[i].NotificationOptionId;
        const objtax = this.AllData.findIndex(o => o.NotificationOptionId === id);
        this.AllData = [...this.AllData.slice(0, objtax), ...this.AllData.slice(objtax + 1)];
      }
      else {
        const id = obj[i].Id;
        const objtax = this.AllData.findIndex(o => o.Id === id);
        this.AllData = [...this.AllData.slice(0, objtax), ...this.AllData.slice(objtax + 1)];
      }
    }
  }

  getUserList(list) {
    const objLsit = [];
    for (let i = 0; i < list.length; i++) {
      const obj = {
        Id: list[i].Id,
        FirstName: list[i].FirstName,
        LastName: list[i].LastName
      };
      objLsit.push(obj);
    }
    return objLsit;
  }

  getUserListActive(list) {
    const objLsit = [];
    for (let i = 0; i < list.length; i++) {
      const obj = {
        Id: list[i].Id,
        Name: list[i].FirstName + ' ' + list[i].LastName,
        FirstName: list[i].FirstName,
        LastName: list[i].LastName
      }
      objLsit.push(obj);
    }
    return objLsit;
  }

  getUserListAvailable(list) {
    const objLsit = [];
    for (let i = 0; i < list.length; i++) {
      const obj = {
        Id: list[i].Id,
        Name: list[i].FirstName + ' ' + list[i].LastName  // + ' ' + list[i].MName
      }
      objLsit.push(obj);
    }
    return objLsit;
  }

  getNotificationListAvailable(list:any[]) : any[] {
    return list.map(notification => ({
      Id: notification.NotificationOptionId,
      Name: notification.Name,
      NotificationAlert:notification.NotificationAlert,
    })); 
  }

  removeAllData(obj, allArray) {
    if (this.SelectionName === 'Units' || this.SelectionName === 'Unit Types') {
      obj.filter((ele) => {
        if (ele) {
          const objtax = allArray.findIndex(o => o.Id === ele.Id);
          if (objtax !== -1) {
            allArray = [...allArray.slice(0, objtax), ...allArray.slice(objtax + 1)];
          }
        }
      });
      this.tempAllData = allArray;
      return allArray;
    } else if(this.SelectionName === 'AvailableNotifications'){
      obj.filter((ele) => {
        const objtax = allArray.findIndex(o => o.NotificationOptionId === ele.Id);
        if (objtax !== -1) {
          allArray = [...allArray.slice(0, objtax), ...allArray.slice(objtax + 1)];
          ele.NotificationOptionId = ele.Id;
          ele.NotificationAlert = ele.NotificationAlert;
          allArray = [...allArray, ele];        }
      });
      this.tempAllData = allArray;
      return allArray;
    } else {
      obj.filter((ele) => {
        const objtax = allArray.findIndex(o => o.Id === ele.Id);
        if (objtax !== -1) {
          allArray = [...allArray.slice(0, objtax), ...allArray.slice(objtax + 1)];
        }
      });
      this.tempAllData = allArray;
      return allArray;
    }
  }

  removeFromActiveData(obj) {
    let i;
    for (i = 0; i < obj.length; i++) {
      if (this.SelectionName === 'Units') {
        const id = obj[i].UnitId;
        const objtax = this.ActiveData.findIndex(o => o.UnitId === id);
        const result = this.ActiveData.slice(0, objtax).concat(this.ActiveData.slice(objtax + 1));
        this.addTotempActiveGrid(id);
        this.ActiveData = result;
      } else {
        const id = obj[i].Id;
        const objtax = this.ActiveData.findIndex(o => o.Id === id);
        // this.ActiveData.splice(objtax, 1);
        const result = this.ActiveData.slice(0, objtax).concat(this.ActiveData.slice(objtax + 1));
        // this.tempActiveGridData = result;
        this.addTotempActiveGrid(id);
        this.ActiveData = result;
      }
    }
    // this.ActiveFilterData=this.ActiveData;
    this.removeFormArrayData(this.ActiveFormArray, this.activeRecords);
    this.gridActiveData.refresh();
  }

  addTotempActiveGrid(id) {
    let obj;
    if (this.SelectionName === 'Units') {
      obj = this.tempActiveGridData.findIndex(o => o.UnitId === id);
    } else {
      obj = this.tempActiveGridData.findIndex(o => o.Id === id);
    }
    this.tempActiveGridData = this.tempActiveGridData.slice(0, obj).concat(this.tempActiveGridData.slice(obj + 1));
    this.masterFilterActiveData = this.masterFilterActiveData.slice(0, obj).concat(this.masterFilterActiveData.slice(obj + 1));
  }

  removeFormArrayData(formArray: FormArray, records) {
    for (let k = 0; k < records.length; k++) {
      if (this.SelectionName === 'Units') {
        formArray.removeAt(formArray.value.findIndex(obj => obj.UnitId === records[k].UnitId));
      } else if(this.SelectionName === 'AvailableNotifications') {
        formArray.removeAt(formArray.value.findIndex(obj => obj.NotificationOptionId === records[k].Id));
      }else {
        formArray.removeAt(formArray.value.findIndex(obj => obj.Id === records[k].Id));
      }
    }
  }

  openAllFilterModal() {
    let popupSize;
    let template: TemplateRef<any>;
    if (this.SelectionName === 'Users') {
      this.AllFilterData = this.AllData;
      this.allUsersModalName = 'All Users';
      this.allDataUsersFilter.show();
    } else if (this.SelectionName === 'AvailableUser') {
      template = this.avialableDataUsersFilter;
      this.AllFilterData = this.tempFilterUserData;
      popupSize = 'modal-lg modal-dialog-centered';
      this.AllFilterData = this.removeAllData(this.ActiveData, this.AllFilterData);
    } else if (this.SelectionName === 'Store' || this.SelectionName === 'AvailableStore') {
      this.allDatastoresFilter.show();
      this.AllFilterData = this.AllData;
      this.createdAll('args1', this.gridallFilterAllStores);
    } else if (this.SelectionName === 'StoreGroup' || this.SelectionName === 'AvailableStoreGroup') {
      this.allDataStoreGroupfilter.show();
      this.AllFilterData = this.AllData;
      this.createdAll('args', this.gridAllStoreGroupData);
    } else if (this.SelectionName === 'Merchandise') {
      this.allMerchModalName = 'All Merchandise';
      this.allDataMercFilter.show();
      this.AllFilterData = this.AllData;
      const column = this.gridFilterMercAlldata.getColumnByField("Name");
      column.headerText = 'Merchandise Name';
      this.gridFilterMercAlldata.refreshColumns();
      this.createdAll('args1', this.gridFilterMercAlldata);
    } else if (this.SelectionName === 'API') {
      this.allMerchModalName = "All API's";
      this.allDataMercFilter.show();
      this.AllFilterData = this.AllData;
      const column = this.gridFilterMercAlldata.getColumnByField("Name");
      column.headerText = "API's Name";
      this.gridFilterMercAlldata.refreshColumns();
      this.createdAll('args1', this.gridFilterMercAlldata);
    }else if (this.SelectionName === 'MerchandisePacks') {
      this.allDataMercPackFilter.show();
      this.AllFilterData = this.AllData;
      this.createdAll('args1', this.gridFilterMercPackAlldata);
    } else if (this.SelectionName === 'Units') {
      this.allDataunitsFilter.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Unit Types') {
      this.allDataunitTypesFilter.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Fees & Charges') {
      this.allDataFeesAndCharges.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
    }
    else if (this.SelectionName === 'Late & Lien') {
      this.allLateandLien.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Insurance') {
      this.allDataInsurancefilter.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'UnitGroups') {
      this.allDataUnitGroupsfilter.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Taxes') {
      this.allDataTaxfilter.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
      this.hidePercentageFilter();
    } else if (this.SelectionName === 'UserGroups') {
      this.AllDataUserGroupfilter.show();
      this.AllFilterData = this.AllData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'MFALocations') {
      this.allMerchModalName = "Active Locations";
      this.allDataMercFilter.show();
      this.AllFilterData = this.AllData;
      const column = this.gridFilterMercAlldata.getColumnByField("Name");
      column.headerText = "Locations";
      this.gridFilterMercAlldata.refreshColumns();
      this.createdAll('args1', this.gridFilterMercAlldata);
    } else if (this.SelectionName === 'MFAUsers') {
      this.AllFilterData = this.AllData;
      this.allUsersModalName = 'Active Users';
      this.allDataUsersFilter.show();
    } else if (this.SelectionName === 'AvailableNotifications') {
      this.allMerchModalName = "All Notifications";
      this.allDataMercFilter.show();
      this.AllFilterData = this.AllData;
      const column = this.gridFilterMercAlldata.getColumnByField("Name");
      column.headerText = "Notifications Name";
      this.gridFilterMercAlldata.refreshColumns();
      this.createdAll('args1', this.gridFilterMercAlldata);
    }   

    if ((this.SelectionName !== 'Users') && (this.SelectionName !== 'Store') && (this.SelectionName !== 'Merchandise') && (this.SelectionName !== 'API') && (this.SelectionName !== 'MerchandisePacks') && (this.SelectionName !== 'Units') && (this.SelectionName !== 'Unit Types') && (this.SelectionName != 'Insurance') && (this.SelectionName !== 'Late & Lien') && (this.SelectionName !== 'Fees & Charges') && (this.SelectionName !== 'AvailableStore')
      && (this.SelectionName !== 'UnitGroups') && (this.SelectionName !== 'Taxes') && (this.SelectionName != 'StoreGroup') &&
      (this.SelectionName != 'AvailableStoreGroup') && (this.SelectionName !== 'UserGroups') && (this.SelectionName !== 'MFALocations')
      && (this.SelectionName !== 'MFAUsers') && (this.SelectionName != 'AvailableNotifications') && (this.SelectionName !== 'SSOUsers')) {
      this.modalRef = this.modalService.show(template, { class: popupSize, backdrop: 'static', keyboard: false });
    }
  }

  openAllEditModal(template: TemplateRef<any>) {
    this.modalRefEdit = this.modalService.show(template, {class: 'modal-dialog modal-dialog-centered', backdrop: 'static', keyboard: false});
  }

  public createdAll(args1, grid: GridComponent) {
    if (grid && grid.filterModule && (<any>grid.filterModule).filterOperators) {
      Object.assign((<any>grid.filterModule).filterOperators, { startsWith: 'contains' });
      let query: any;
      query = this.queryAll;
      if (query !== undefined) {
        if (query.length !== 0) {
          query.queries[0].e.predicates.forEach(element => {
            grid.filterModule.filterByColumn(element.field, element.operator, element.value, 'and', false, false);
          });
        }
      }
      grid.refreshColumns();
    }
  }

  public createdActive(args1, grid: GridComponent) {
    if (grid && grid.filterModule && (<any>grid.filterModule).filterOperators) {
      Object.assign((<any>grid.filterModule).filterOperators, { startsWith: 'contains' });
      let query: any;
      query = this.queryActive;
      if (query !== undefined) {
        if (query.length !== 0) {
          query.queries[0].e.predicates.forEach(element => {
            grid.filterModule.filterByColumn(element.field, element.operator, element.value, 'and', false, false);
          });
        }
      }
      grid.refreshColumns();
    }
  }

  hidePercentageFilter() {
    if (this.SelectionName == 'Taxes') {
      this.gridActiveTaxData.element.querySelectorAll('.e-filterdiv')[this.gridActiveTaxData.getColumnIndexByField('Percentage')].classList.add('e-hide');
      this.gridAllTaxData.element.querySelectorAll('.e-filterdiv')[this.gridAllTaxData.getColumnIndexByField('Percentage')].classList.add('e-hide');
    }
  }

  openActiveFilterModal() {
    let popupSize;
    let template: TemplateRef<any>;
    if (this.SelectionName === 'Users') {
      this.activeUsersModalName = 'Active Users';
      this.activeDataUsersGridFilter.show();
      this.tempActiveGridData = this.getActiveFilterUsers(this.ActiveData, this.AllData);
      this.ActiveFilterData = this.tempActiveGridData;
    } else if (this.SelectionName === 'AvailableUser') {
      template = this.activeDataUsersFilter;
      this.ActiveFilterData = this.getActiveFilterUsers(this.tempActiveGridData, this.AllUsers);
      popupSize = 'modal-lg modal-dialog-centered';
    } else if (this.SelectionName === 'Store' || this.SelectionName === 'AvailableStore') {
      this.activeDataStoresFilter.show();
      this.tempActiveGridData = this.getActiveFilterUsers(this.ActiveData, this.AllData);
      this.ActiveFilterData = this.tempActiveGridData;
      this.createdActive('', this.gridFilterStoreActivedata);
    } else if (this.SelectionName === 'StoreGroup' || this.SelectionName == 'AvailableStoreGroup') {
      this.activeDataStoreGroupFilter.show();
      this.tempActiveGridData = this.getActiveFilterUsers(this.ActiveData, this.AllData);
      this.ActiveFilterData = this.tempActiveGridData;
      this.createdActive('', this.gridActiveStoreGroupData);
    } else if (this.SelectionName === 'Merchandise') {
      this.activeMerchModalName = 'Active Merchandise';
      this.activeDataMercFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      const column = this.gridFilterMercActivedata.getColumnByField("Name");
      column.headerText = 'Merchandise Name';
      this.gridFilterMercActivedata.refreshColumns();
      this.createdActive('', this.gridFilterMercActivedata);
    } else if (this.SelectionName === 'API') {
      this.activeMerchModalName = "Active API's";
      this.activeDataMercFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      const column = this.gridFilterMercActivedata.getColumnByField("Name");
      column.headerText = "API's Name";
      this.gridFilterMercActivedata.refreshColumns();
      this.createdActive('', this.gridFilterMercActivedata);
    } else if (this.SelectionName === 'MerchandisePacks') {
      this.activeDataMercPackFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      this.createdActive('', this.gridFilterMercPackActivedata);
    } else if (this.SelectionName === 'Units') {
      this.activeDataunitsFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Unit Types') {
      this.activeDataunitTypesFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Fees & Charges') {
      this.activeDataFeesAndCharges.show();
      this.ActiveFilterData = this.tempActiveGridData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Late & Lien') {
      this.activeDataLateAndLien.show();
      this.ActiveFilterData = this.tempActiveGridData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Insurance') {
      this.activeInsurancefilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'UnitGroups') {
      this.activeDataUnitGroupsFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      popupSize = 'modal-md modal-dialog-centered';
    } else if (this.SelectionName === 'Taxes') {
      this.activeDataTaxFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      this.hidePercentageFilter();
    } else if (this.SelectionName === 'UserGroups') {
      this.ActiveDataUserGroupFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
    } else if (this.SelectionName === 'MFALocations') {
      this.activeMerchModalName = "Excluded Locations";
      this.activeDataMercFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      const column = this.gridFilterMercActivedata.getColumnByField("Name");
      column.headerText = "Locations";
      this.gridFilterMercActivedata.refreshColumns();
      this.createdActive('', this.gridFilterMercActivedata);
    } else if(this.SelectionName === 'MFAUsers') {
      this.activeUsersModalName = 'Excluded Users';
      this.activeDataUsersGridFilter.show();
      this.tempActiveGridData = this.getActiveFilterUsers(this.ActiveData, this.AllData);
      this.ActiveFilterData = this.tempActiveGridData;
    } else if (this.SelectionName === 'AvailableNotifications') {
      this.activeMerchModalName = "Active Notifications";
      this.activeDataMercFilter.show();
      this.ActiveFilterData = this.tempActiveGridData;
      const column = this.gridFilterMercActivedata.getColumnByField("Name");
      column.headerText = "Notification Name";
      this.gridFilterMercActivedata.refreshColumns();
      this.createdActive('', this.gridFilterMercActivedata);
    }

    if ((this.SelectionName !== 'Users') && (this.SelectionName !== 'Store') && (this.SelectionName !== 'Merchandise') && (this.SelectionName !== 'API') && (this.SelectionName !== 'MerchandisePacks') && (this.SelectionName !== 'Units') && (this.SelectionName !== 'Unit Types') && (this.SelectionName !== 'Fees & Charges') && (this.SelectionName !== 'Insurance') && (this.SelectionName !== 'Late & Lien') && (this.SelectionName !== 'AvailableStore')
      && (this.SelectionName !== 'UnitGroups') && (this.SelectionName !== 'Taxes') && (this.SelectionName !== 'StoreGroup') &&
      (this.SelectionName !== 'AvailableStoreGroup') && (this.SelectionName !== 'UserGroups') && (this.SelectionName !== 'MFALocations')
      && (this.SelectionName !== 'MFAUsers') && (this.SelectionName !== 'AvailableNotifications') && (this.SelectionName !== 'SSOUsers')) {
      this.modalRef = this.modalService.show(template, { class: popupSize, backdrop: 'static', keyboard: false });
    }
  }

  loadToAllGrid(grid: GridComponent, type) {
    const query = grid.getDataModule().generateQuery(false); // get grid filter query
    this.queryAll = query;
    this.tempAllData = this.AllData;
    const ref = this;
    let filterData = [];
    grid.getDataModule().getData({}, query).then(function (e: any) {
      filterData = e.result;
      if (ref.SelectionName === 'AvailableUser') {
        ref.AllDataDisplay = ref.getUserListAvailable(filterData);
      } else {
        ref.AllDataDisplay = filterData;
      }
    });

    if (type === 'OK') {
      this.isFilterAll = true;
    } else if (type === 'CLEAR') {
      this.isFilterAll = false;
    }
    if (query.queries.length !== 0) {
      this.infoClick(type);
    }
    if (this.SelectionName === 'Users') {
      this.allDataUsersFilter.hide();
    } else if (this.SelectionName === 'Store' || this.SelectionName === 'AvailableStore') {
        this.allDatastoresFilter.hide();
      } else if (this.SelectionName === 'StoreGroup' || this.SelectionName === 'AvailableStoreGroup') {
        this.allDataStoreGroupfilter.hide();
      } else if (this.SelectionName === 'Merchandise') {
        this.allDataMercFilter.hide();
      } else if (this.SelectionName === 'API') {
        this.allDataMercFilter.hide();
      } else if (this.SelectionName === 'MerchandisePacks') {
        this.allDataMercPackFilter.hide();
      } else if (this.SelectionName === 'Units') {
        this.allDataunitsFilter.hide();
      } else if (this.SelectionName === 'Unit Types') {
        this.allDataunitTypesFilter.hide();
      } else if (this.SelectionName === 'Insurance') {
        this.allDataInsurancefilter.hide();
      } else if (this.SelectionName === 'Late & Lien') {
        this.allLateandLien.hide();
      } else if (this.SelectionName === 'Fees & Charges') {
        this.allDataFeesAndCharges.hide();
      } else if (this.SelectionName === 'UnitGroups') {
        this.allDataUnitGroupsfilter.hide();
      } else if (this.SelectionName === 'Taxes') {
        this.allDataTaxfilter.hide();
      } else if (this.SelectionName === 'UserGroups') {
        this.AllDataUserGroupfilter.hide();
      } else if (this.SelectionName == 'UserGroups') {
        this.AllDataUserGroupfilter.hide();
      } else if (this.SelectionName === 'MFALocations') {
        this.allDataMercFilter.hide();
      } else if (this.SelectionName === 'MFAUsers' || this.SelectionName === 'SSOUsers') {
        this.allDataUsersFilter.hide();
      } else if (this.SelectionName === 'AvailableNotifications') {
        this.allDataMercFilter.hide();
      } else {
        this.modalRef.hide();
      }
  }

  clearFilterAll(grid: GridComponent, type) {
    const ref = this;
    const query = grid.getDataModule().generateQuery(false);
    this.queryAll = [];
    if (query.queries.length !== 0) {
      this.AllData = this.removeAllData(this.ActiveData, ref.tempAllData);
      this.AllFilterData = this.AllData;
      ref.gridAlldata.refresh();
    }
    grid.clearFiltering();
    this.infoClick(type);
    this.AllDataDisplay = this.AllData;
    this.disableFilter = true;
    this.isFilterAll = false;
    this.hidePercentageFilter();
    const source = timer(250);
    this.sub3 = this.appService.waitForStable$(source).subscribe(val => this.gridAlldata.refresh());
  }

  clearFilterActive(grid: GridComponent, type) {
    const ref = this;
    this.queryActive = [];
    const query = grid.getDataModule().generateQuery(false);
    if (query.queries.length !== 0) {
      ref.ActiveData = this.removeAllData(this.AllData, ref.masterFilterActiveData);
      ref.ActiveFilterData = ref.ActiveData;
      this.isFilterActive = false;
    }
    grid.clearFiltering();
    this.infoClick(type);
    this.ActiveDataDisplay = this.ActiveData;
    this.disableFilterActive = true;
    this.hidePercentageFilter()
  }

  loadToActiveGrid(grid: GridComponent, type) {
    const query = grid.getDataModule().generateQuery(false); // get grid filter query
    this.queryActive = query;
    const ref = this;
    let filterData = [];
    grid.getDataModule().getData({}, query).then(function (e: any) {
      filterData = e.result;

      if (ref.SelectionName === 'AvailableUser') {
        ref.ActiveDataDisplay = ref.getUserListAvailable(filterData);
        ref.tempActiveGridData = ref.ActiveData;  //
      } else {
        ref.ActiveDataDisplay = filterData;
        ref.tempActiveGridData = ref.ActiveData;  //
      }
    });
    if (type === 'OK') {
      this.isFilterActive = true;
    } else if (type === 'CLEAR') {
      this.isFilterActive = false;
    }
    if (query.queries.length !== 0) {
      this.infoClick(type);
    }
    if (type !== 'filter') {
      if (this.SelectionName === 'Users') {
        this.activeDataUsersGridFilter.hide();
      } else if (this.SelectionName === 'Store' || this.SelectionName === 'AvailableStore') {
          this.activeDataStoresFilter.hide();
        } else if (this.SelectionName === 'StoreGroup' || this.SelectionName === 'AvailableStoreGroup') {
          this.activeDataStoreGroupFilter.hide();
        } else if (this.SelectionName === 'Merchandise') {
          this.activeDataMercFilter.hide();
        } else if (this.SelectionName === 'API') {
          this.activeDataMercFilter.hide();
        } else if (this.SelectionName === 'MerchandisePacks') {
          this.activeDataMercPackFilter.hide();
        } else if (this.SelectionName === 'Units') {
          this.activeDataunitsFilter.hide();
        } else if (this.SelectionName === 'Unit Types') {
          this.activeDataunitTypesFilter.hide();
        } else if (this.SelectionName === 'Insurance') {
          this.activeInsurancefilter.hide();
        } else if (this.SelectionName === 'Late & Lien') {
          this.activeDataLateAndLien.hide();
        } else if (this.SelectionName === 'Fees & Charges') {
          this.activeDataFeesAndCharges.hide();
        } else if (this.SelectionName === 'UnitGroups') {
          this.activeDataUnitGroupsFilter.hide();
        } else if (this.SelectionName === 'Taxes') {
          this.activeDataTaxFilter.hide();
        } else if (this.SelectionName === 'UserGroups') {
          this.ActiveDataUserGroupFilter.hide();
        } else if (this.SelectionName === 'MFALocations') {
          this.activeDataMercFilter.hide();
        } else if (this.SelectionName === 'MFAUsers' || this.SelectionName === 'SSOUsers') {
          this.activeDataUsersGridFilter.hide();
        } else if (this.SelectionName === 'AvailableNotifications') {
          this.activeDataMercFilter.hide()
        } else {
          this.modalRef.hide();
        }
      const source = timer(250);
      this.sub4 = this.appService.waitForStable$(source).subscribe(val => this.gridAlldata.refresh());
    }
  }


  ///////////////////// Toast///////////////////////

  public onCreate(): void {
    const source = timer(200);
    this.sub5 = this.appService.waitForStable$(source).subscribe(val => this.toastObj.show(this.toasts[0]));
  }

  public infoClick(type): void {
    if (type === 'OK') {
      this.toastObj.hide('All');
      this.toastObj.show(this.toasts[0]);
    } else if (type === 'CLEAR') {
      this.toastObj.hide('All');
      this.toastObj.show(this.toasts[1]);
    }
  }

  get tempStorageListForReports() {
    return this.tempDataService.storeListForReports;
  }

  get tempStorageList() {
    return this.tempDataService.storeList;
  }

  get tempMerchandiseServiceGet() {
    return this.tempDataService.merchandiseList;
  }

  get tempMerchandisePackServiceGet() {
    return this.tempDataService.merchandisePackList;
  }

  get tempUsersServiceGet() {
    return this.tempDataService.usersList;
  }

  get tempNotificationServiceGet() {
    return this.tempDataService.notificationList;
  }

  get tempTruckRentalServiceGet() {
    return this.tempDataService.truckRentalList;
  }

  get tempUnitsServiceGet() {
    return this.tempDataService.allUnitsList;
  }

  get tempUnitTypesServiceGet() {
    return this.tempDataService.unitTypeList;
  }

  get tempFeesAndChargesServiceGet() {
    return this.tempDataService.feesAndChargesList;
  }

  checkFilter() {
  }

  ngOnDestroy(): void {
    this.isOninitExecuted = false;
    if (this.sub) {
      this.sub.unsubscribe()
    }
    if (this.sub2) {
      this.sub2.unsubscribe()
    }
    if (this.sub3) {
      this.sub3.unsubscribe()
    }
    if (this.sub4) {
      this.sub4.unsubscribe()
    }
    if (this.sub5) {
      this.sub5.unsubscribe()
    }
  }

  makeTwoDecimals(value) {
    var with2Decimals = value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    return with2Decimals
  }


  ///////////////// MFA Settings Related ////////////////
  onClickNamedLocType(val) {
    if(val == 1) {
      this.displayCountries = true;
      this.displayIp = false;
    } else {
      this.displayIp = true;
      this.displayCountries = false;
    }
  }

  // On select Named Location
  onSelectNamedLocation(eve) {
    // let selectedLoc = this.NamedLocations.find((ele) => ele.id == eve.target.value) 
    // if(selectedLoc) {
    //   this.NamedLocationForm.patchValue({
    //     Name: selectedLoc.displayName,
    //     Trusted: selectedLoc.isTrusted,
    //     Countries: selectedLoc.
    //   })
    // } 
  }

  // On click create Named Location
  onCreateNamedLocation() {

  }

  openEditLocModal(type) {
    this.editNamedLoc.emit(type);
  }

  notificationAleret(event,data){
    
     // Get the selected records.
     const notificationOptionId = data?.NotificationOptionId;

  // Search for the form control with matching NotificationOptionId
  var test = this.ActiveFormArray.controls.find((ctrl: FormArray) => {
    return ctrl.value?.NotificationOptionId === notificationOptionId;
   
  });
  test.value.NotificationAlert=event.target.checked;
  test=test.value;
    this.isFormDirty.emit(true);
     this.insertFormArrayData(this.ActiveFormArray,test);
  }

  onRowSelecting(args: any): void {
    const target = args?.target as HTMLElement;
    const td = target?.closest('td');
    const colIndex = td?.getAttribute('aria-colindex');
    if (colIndex === '3') {
      args.cancel = true;
      if (target.tagName.toLowerCase() !== 'input') {
        const checkbox = td.querySelector('input[type="checkbox"]') as HTMLInputElement;
        if (checkbox) {
          checkbox.checked = !checkbox.checked;
          const event = new Event('change', { bubbles: true });
          checkbox.dispatchEvent(event);
        }
      }
    }
    if (this.SelectionName === 'MFAUsers' && args.data.isSsoEnabledUser === true) {
      args.cancel = true;  // prevents this row from being selected
    }
    else if (this.SelectionName === 'MFAUsers' && args.rowIndex === 0) { // Header checkbox clicked
      args.cancel = true;
      const excludedUserGrid = document.getElementById('excludedUserGrid') as HTMLElement;
      const headerFrame = excludedUserGrid.querySelector('.e-frame, e-icons') as HTMLElement;
      const headerCheckbox = excludedUserGrid.querySelector('.e-headercell .e-checkbox-wrapper input') as HTMLInputElement;

      if (!headerFrame || !headerCheckbox) return;

      const isChecked = headerCheckbox.checked;

      if (isChecked) {
        // UNSELECT ALL
        this.gridActiveData.clearSelection();
        headerCheckbox.checked = false;

        setTimeout(() => {
          headerFrame.classList.remove('e-check', 'e-stop');
          headerFrame.classList.add('e-uncheck');
        }, 50);
      } else {
        // SELECT ONLY ALLOWED ROWS
        const allowedIndexes: number[] = [];
        this.ActiveDataDisplay.forEach((item: any, i: number) => {
          if (!item.isSsoEnabledUser) {
            allowedIndexes.push(i);
          }
        });

        this.gridActiveData.clearSelection();
        this.gridActiveData.selectRows(allowedIndexes);

        headerCheckbox.checked = true;
        setTimeout(() => {
          headerFrame.classList.remove('e-uncheck', 'e-stop');
          headerFrame.classList.add('e-check');
        }, 50);
      }
    }
  }
}
